var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0846 14.8828H1.91797C1.62472 14.8828 1.38672 15.1215 1.38672 15.4141C1.38672 15.7073 1.62472 15.9453 1.91797 15.9453H16.0846C16.3779 15.9453 16.6159 15.7073 16.6159 15.4141C16.6159 15.1215 16.3779 14.8828 16.0846 14.8828Z",
    fill: "#003A9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9505 15.4143V2.29385C10.9505 1.88302 10.7465 1.49839 10.4058 1.26748C10.0651 1.03727 9.63231 0.990518 9.25052 1.14352L3.58385 3.41019C3.11352 3.59789 2.80469 4.05406 2.80469 4.56123V15.4143C2.80469 15.7083 3.04269 15.9456 3.33594 15.9456H10.4193C10.7125 15.9456 10.9505 15.7083 10.9505 15.4143ZM5.46094 13.8206H8.29427C8.58752 13.8206 8.82552 13.5826 8.82552 13.2893C8.82552 12.9968 8.58752 12.7581 8.29427 12.7581H5.46094C5.16769 12.7581 4.92969 12.9968 4.92969 13.2893C4.92969 13.5826 5.16769 13.8206 5.46094 13.8206ZM5.46094 11.3414H8.29427C8.58752 11.3414 8.82552 11.1034 8.82552 10.8101C8.82552 10.5176 8.58752 10.2789 8.29427 10.2789H5.46094C5.16769 10.2789 4.92969 10.5176 4.92969 10.8101C4.92969 11.1034 5.16769 11.3414 5.46094 11.3414ZM5.46094 8.86223H8.29427C8.58752 8.86223 8.82552 8.62423 8.82552 8.33098C8.82552 8.03843 8.58752 7.79973 8.29427 7.79973H5.46094C5.16769 7.79973 4.92969 8.03843 4.92969 8.33098C4.92969 8.62423 5.16769 8.86223 5.46094 8.86223ZM5.46094 6.38306H8.29427C8.58752 6.38306 8.82552 6.14506 8.82552 5.85181C8.82552 5.55927 8.58752 5.32056 8.29427 5.32056H5.46094C5.16769 5.32056 4.92969 5.55927 4.92969 5.85181C4.92969 6.14506 5.16769 6.38306 5.46094 6.38306Z",
    fill: "#003A9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6581 4.9668V15.4147C11.6581 15.6053 11.6156 15.7852 11.5391 15.946H14.6685C14.9617 15.946 15.1997 15.7087 15.1997 15.4147V6.20638C15.1997 5.52213 14.6444 4.9668 13.9601 4.9668H11.6581Z",
    fill: "#003A9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.a0dbbbfd4c10e82c3db397961ad48dad.svg";
export { ForwardRef as ReactComponent };